// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Idbq","containerItemsCenter":"Skeleton_containerItemsCenter__1rwad"};